/**
 * Seção "Tom de voz" em modo edição (Brief 4 · Tela 2 · PR5).
 *
 * As 3 dimensões do `voiceProfile` (formality/warmth/pace) são editadas como
 * INPUTS DE TEXTO. O serializer/Prisma armazena `voiceProfile` como JSON de
 * strings livres (sem enum no `CreatePersonaDto`); os valores reais variam por
 * persona ("neutro"/"acolhedor"/"ágil"/"direto"...). Um `select` fabricaria um
 * conjunto fechado que o backend NÃO impõe e poderia excluir valores válidos
 * (zero dado falso) — daí texto livre. O gabarito r5 usa sliders de 5 pontos,
 * mas isso pressupõe escala canônica inexistente no modelo. R15: o backend grava
 * o objeto inteiro, então editar qualquer dimensão substitui `voiceProfile` no draft.
 */

import { VOICE_DIMENSION_LABELS } from '../persona-labels';

import type { PersonaVoiceProfile } from '../types';
import type { PersonaForm } from '../use-persona-form';

const DIMENSIONS: (keyof PersonaVoiceProfile)[] = ['formality', 'warmth', 'pace'];

const PLACEHOLDERS: Record<keyof PersonaVoiceProfile, string> = {
  formality: 'ex.: neutro',
  warmth: 'ex.: acolhedor',
  pace: 'ex.: normal',
};

export function SectionVoiceEdit({ form }: { form: PersonaForm }): JSX.Element {
  const { voiceProfile } = form.draft;

  return (
    <section className="pe-panel">
      <h2 className="pe-panel__title">Tom de voz</h2>
      <p className="pe-panel__subtitle">
        Como a IA assume a voz: formalidade, acolhimento e ritmo.
      </p>
      <div className="pe-grid-3">
        {DIMENSIONS.map((dim) => (
          <div className="pe-field" key={dim}>
            <label className="pe-field__label" htmlFor={`pe-voice-${dim}`}>
              {VOICE_DIMENSION_LABELS[dim]}
            </label>
            <input
              id={`pe-voice-${dim}`}
              type="text"
              className="pe-input"
              value={voiceProfile[dim]}
              placeholder={PLACEHOLDERS[dim]}
              onChange={(e) => {
                form.set('voiceProfile', { ...voiceProfile, [dim]: e.target.value });
              }}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
